<div class="servicios-page">
  <section class="bg-light rounded-3 mx-1 mt-1 mb-2 p-3">
    <div class="servicios-header d-flex align-items-center justify-content-between flex-nowrap gap-2">
      <div class="d-flex align-items-center gap-2 flex-shrink-0">
        <h1 class="servicios-title mb-0">Seguimiento de Servicios</h1>
        <span class="badge rounded-pill servicios-badge text-nowrap">{{ resumen?.totalServicios ?? 0 }} SERVICIOS</span>
      </div>

      <div class="filter-group d-flex align-items-center flex-nowrap gap-2">
        <label class="filter-chip" (click)="abrirFiltro(servicioSelect, $event)" (keydown.enter)="abrirFiltro(servicioSelect, $event)">
          <mat-icon class="filter-chip__icon">confirmation_number</mat-icon>
          <span class="filter-chip__label">Servicio:</span>
          <select #servicioSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedTipoServicioId" (change)="onFilterChange()">
            <option *ngFor="let opt of tipoServicioOptions; trackBy: trackByOptionId" [ngValue]="opt.id">
              {{ opt.text }}
            </option>
          </select>
          <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
        </label>

        <label class="filter-chip" (click)="abrirFiltro(clienteSelect, $event)" (keydown.enter)="abrirFiltro(clienteSelect, $event)">
          <mat-icon class="filter-chip__icon">apartment</mat-icon>
          <span class="filter-chip__label">Cliente:</span>
          <select #clienteSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedClientId" (change)="onFilterChange()">
            <option *ngFor="let opt of clientOptions; trackBy: trackByOptionId" [ngValue]="opt.id">
              {{ opt.text }}
            </option>
          </select>
          <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
        </label>

        <label class="filter-chip" (click)="abrirFiltro(responsableSelect, $event)" (keydown.enter)="abrirFiltro(responsableSelect, $event)">
          <mat-icon class="filter-chip__icon">person</mat-icon>
          <span class="filter-chip__label">Responsable:</span>
          <select #responsableSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedResponsableId" (change)="onFilterChange()">
            <option *ngFor="let opt of responsableOptions; trackBy: trackByOptionId" [ngValue]="opt.id">
              {{ opt.text }}
            </option>
          </select>
          <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
        </label>

        <label class="filter-chip" (click)="abrirFiltro(vigenciaSelect, $event)" (keydown.enter)="abrirFiltro(vigenciaSelect, $event)">
          <mat-icon class="filter-chip__icon">event</mat-icon>
          <span class="filter-chip__label">Año:</span>
          <select #vigenciaSelect class="filter-chip__select text-truncate" [(ngModel)]="selectedAnioVigencia" (change)="onFilterChange()">
            <option *ngFor="let opt of anioOptions; trackBy: trackByOptionId" [ngValue]="opt.id">
              {{ opt.text }}
            </option>
          </select>
          <mat-icon class="filter-chip__chevron">expand_more</mat-icon>
        </label>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary reporte-btn d-inline-flex align-items-center gap-1"
          (click)="exportarPdf()"
        >
          <mat-icon class="reporte-btn__icon">picture_as_pdf</mat-icon> REPORTE
        </button>
      </div>
    </div>

    <div class="row mt-2 g-2">
      <div class="col-6 col-lg-3">
        <div class="card stat-tile">
          <div class="card-body d-flex align-items-center gap-2">
            <span class="stat-icon stat-icon--purple"><mat-icon>inventory_2</mat-icon></span>
            <div>
              <div class="stat-tile__label">SERVICIOS</div>
              <div class="stat-tile__value">
                {{ resumen?.totalServicios ?? 0 }} <span class="stat-tile__sub">contratados</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div class="card stat-tile">
          <div class="card-body d-flex align-items-center gap-2">
            <span class="stat-icon stat-icon--blue"><mat-icon>schedule</mat-icon></span>
            <div>
              <div class="stat-tile__label">HORAS CONTRATADAS</div>
              <div class="stat-tile__value">
                {{ resumen?.horasContratadasTotales ?? 0 }} <span class="stat-tile__sub">hrs</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div class="card stat-tile">
          <div class="card-body d-flex align-items-center gap-2">
            <span class="stat-icon stat-icon--orange"><mat-icon>bar_chart</mat-icon></span>
            <div>
              <div class="stat-tile__label">HORAS USADAS</div>
              <div class="stat-tile__value">
                {{ resumen?.horasUsadasTotales ?? 0 }}
                <span class="stat-tile__sub stat-tile__sub--orange">{{ resumen?.porcentajeConsumoTotal ?? 0 }}% consumido</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-lg-3">
        <div class="card stat-tile">
          <div class="card-body d-flex align-items-center gap-2">
            <span class="stat-icon stat-icon--green"><mat-icon>hourglass_bottom</mat-icon></span>
            <div>
              <div class="stat-tile__label">SALDO DE HORAS</div>
              <div class="stat-tile__value">
                {{ resumen?.saldoHorasTotal ?? 0 }} <span class="stat-tile__sub stat-tile__sub--green">disponibles</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="row" *ngIf="!isLoading && paginatedServiceCards.length > 0">
    <div
      *ngFor="let servicio of paginatedServiceCards; trackBy: trackByCardId"
      class="col-12 col-md-6 col-xl-4 mt-1 mb-2"
    >
      <article class="card servicio-card h-100 mt-1 mb-1">
        <div class="card-body px-3 pt-3 pb-1 d-flex flex-column">
          <div class="servicio-card__meta-row">
            <span class="servicio-card__categoria">{{ servicio.categoria }}</span>
            <span class="servicio-card__saldo">SALDO: {{ saldoLabel(servicio) }}</span>
          </div>

          <h2 class="servicio-card__title mb-0">{{ servicio.aplicacion }}</h2>
          <p class="servicio-card__client mb-2">{{ servicio.client }}</p>

          <div class="mb-2">
            <div class="d-flex align-items-baseline justify-content-between mb-1">
              <span class="servicio-card__section-title">Consumo de horas</span>
              <span class="servicio-card__pct">{{ servicio.porcentajeConsumo }}%</span>
            </div>
            <div class="progress servicio-progress-track mb-1">
              <div
                class="progress-bar servicio-progress-track__value"
                [style.width.%]="servicio.porcentajeConsumo"
              ></div>
            </div>
            <div class="servicio-card__horas-label">{{ servicio.horasUsadas }} / {{ servicio.horasContratadas }} hrs</div>
          </div>

          <div class="row mx-0 mb-2 servicio-card__info">
            <div class="col-6 px-0">
              <span class="servicio-card__info-label">Vigencia</span>
              <span class="servicio-card__info-value">
                {{ formatFecha(servicio.fechaInicio) }} al {{ formatFecha(servicio.fechaFin) }}
              </span>
            </div>
            <div class="col-6 px-0">
              <span class="servicio-card__info-label">Responsable</span>
              <span class="servicio-card__info-value">
                <img class="servicio-card__owner-icon rounded-circle" src="assets/img/faces/profile.png" alt="" />{{ servicio.owner }}
              </span>
            </div>
          </div>

          <section class="servicio-note p-2 mb-2">
            <div class="servicio-note__header mb-1">
              <span class="servicio-note__label">Observaciones</span>
              <span class="servicio-note__date" *ngIf="servicio.noteDate">{{ servicio.noteDate }}</span>
            </div>
            <p class="servicio-note__text mb-0">{{ servicio.note }}</p>
          </section>

          <div class="d-flex align-items-center justify-content-end gap-2 mt-auto pt-2 pb-2">
            <button
              type="button"
              class="btn btn-sm servicio-btn-historial py-0 px-2"
              (click)="openHistorial(servicio)"
            >
              <mat-icon class="servicio-btn__icon">arrow_outward</mat-icon>
              Detalle
            </button>
          </div>
        </div>
      </article>
    </div>
  </div>

  <div class="row justify-content-end" *ngIf="!isLoading && serviceCards.length > 0">
    <div class="col-4 ml-auto">
      <div class="portfolio-pagination mt-1 mb-2 py-1">
        <button
          type="button"
          class="pagination-nav px-2 py-0"
          (click)="goToPreviousPage()"
          [disabled]="currentPage === 1"
        >
          <span class="pagination-nav__icon">&#8249;</span>
          <span>Anterior</span>
        </button>

        <div class="pagination-divider"></div>

        <button
          type="button"
          class="pagination-page"
          *ngFor="let item of paginationItems; trackBy: trackByPaginationItem"
          [class.pagination-page--active]="item === currentPage"
          [class.pagination-page--dots]="item === '...'"
          [disabled]="item === '...'"
          (click)="onPaginationItemClick(item)"
        >
          {{ item }}
        </button>

        <div class="pagination-divider"></div>

        <button
          type="button"
          class="pagination-nav px-2 py-0"
          (click)="goToNextPage()"
          [disabled]="currentPage === totalPages"
        >
          <span>Siguiente</span>
          <span class="pagination-nav__icon">&#8250;</span>
        </button>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="isLoading">
    <div class="col-12">
      <article class="card servicio-card">
        <div class="card-body p-3 text-center">Cargando servicios...</div>
      </article>
    </div>
  </div>

  <div class="row" *ngIf="!isLoading && serviceCards.length === 0">
    <div class="col-12">
      <article class="card servicio-card">
        <div class="card-body p-3 text-center">No se encontraron servicios para los filtros seleccionados.</div>
      </article>
    </div>
  </div>
</div>
